import { render, staticRenderFns } from "./contractT.vue?vue&type=template&id=c50d18c6&scoped=true&"
import script from "./contractT.vue?vue&type=script&lang=js&"
export * from "./contractT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50d18c6",
  null
  
)

export default component.exports